<app-menu></app-menu>

<main class="controldossie-page">
  <aside class="dossie-sidebar">
    <div class="sidebar-brand">
      <p>Visão pessoal</p>
      <h2>ControlDossie</h2>
      <span>Dossiês privados por usuário e ambiente.</span>
    </div>

    <section class="sidebar-card">
      <div class="sidebar-card__header">
        <strong>Resumo</strong>
        <span>{{ summary.total || 0 }}</span>
      </div>
      <p class="sidebar-note">A lista de dossiês fica abaixo da pesquisa. Clique em um dossiê para abrir sua tela de trabalho.</p>
    </section>
  </aside>

  <section class="dossie-main" *ngIf="canAccess; else accessDenied">
    <ng-container *ngIf="!selectedDossie; else dossieDetailScreen">
    <header class="page-hero">
      <div>
        <span class="eyebrow">ControlPS / Dossiês</span>
        <h1>ControlDossie</h1>
        <p>Organize evidências, textos e arquivos em uma pasta privada do ControlDocs.</p>
      </div>
      <button type="button" class="primary-btn" (click)="openDossieModal()">
        <mat-icon>add</mat-icon>
        Novo dossiê
      </button>
    </header>

    <section class="metrics-grid">
      <article>
        <span>Total</span>
        <strong>{{ summary.total || 0 }}</strong>
        <small>Dossiês privados</small>
      </article>
      <article>
        <span>Coletando</span>
        <strong>{{ summary.collecting || 0 }}</strong>
        <small>Com evidências em montagem</small>
      </article>
      <article>
        <span>Para análise</span>
        <strong>{{ summary.ready || 0 }}</strong>
        <small>Marcados para IA</small>
      </article>
      <article>
        <span>Organizados</span>
        <strong>{{ summary.organized || 0 }}</strong>
        <small>Consolidados</small>
      </article>
    </section>

    <section class="toolbar-card">
      <div class="search-field">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="loadDossies()"
          placeholder="Buscar dossiê por título ou objetivo">
      </div>
      <select [(ngModel)]="statusFilter" (change)="loadDossies()">
        <option value="">Todos os status</option>
        <option value="DRAFT">Rascunho</option>
        <option value="COLLECTING">Coletando</option>
        <option value="READY_FOR_ANALYSIS">Pronto para análise</option>
        <option value="ORGANIZED">Organizado</option>
        <option value="FINALIZED">Finalizado</option>
      </select>
      <button type="button" class="ghost-btn" (click)="loadDossies()">Filtrar</button>
    </section>

    <article class="panel dossie-list-panel full-list-panel">
        <div class="panel-header">
          <div>
            <h2>Dossiês</h2>
            <p>{{ dossies.length }} item(ns) encontrados</p>
          </div>
        </div>

        <div class="dossie-table">
          <div class="table-head">
            <span>Título</span>
            <span>Status</span>
            <span>Evidências</span>
            <span>Atualização</span>
            <span>Ações</span>
          </div>
          <button
            type="button"
            class="table-row"
            *ngFor="let dossie of dossies"
            (click)="selectDossie(dossie)">
            <span class="title-cell">
              <mat-icon>folder_special</mat-icon>
              <strong>{{ dossie.title }}</strong>
            </span>
            <span><small class="status-chip">{{ statusLabel(dossie.status) }}</small></span>
            <span>{{ dossie.evidences_count || 0 }}</span>
            <span>{{ formatDate(dossie.updated_at) }}</span>
            <span class="row-actions" (click)="$event.stopPropagation()">
              <button type="button" title="Editar" (click)="openDossieModal(dossie)"><mat-icon>edit</mat-icon></button>
              <button type="button" title="Excluir" class="danger" (click)="deleteDossie(dossie)"><mat-icon>delete</mat-icon></button>
            </span>
          </button>
          <div class="empty-state" *ngIf="!loading && !dossies.length">
            <mat-icon>folder_off</mat-icon>
            <strong>Nenhum dossiê encontrado.</strong>
            <span>Crie o primeiro dossiê para abrir a pasta no ControlDocs.</span>
          </div>
        </div>
    </article>
    </ng-container>

    <ng-template #dossieDetailScreen>
      <header class="page-hero detail-hero">
        <div class="detail-hero__main">
          <button type="button" class="ghost-btn back-btn" (click)="backToList()">
            <mat-icon>arrow_back</mat-icon>
            Voltar para dossiês
          </button>
          <span class="eyebrow">ControlDossie / Dossiê</span>
          <h1>{{ selectedDossie?.title }}</h1>
          <p>{{ selectedDossie?.objective }}</p>
        </div>
        <div class="detail-hero__actions">
          <small class="status-chip">{{ statusLabel(selectedDossie?.status) }}</small>
          <button type="button" class="ghost-btn" (click)="selectedDossie && openDossieModal(selectedDossie)">
            <mat-icon>edit</mat-icon>
            Editar
          </button>
          <button type="button" class="ghost-btn" (click)="openEvidenceModal()">
            <mat-icon>attach_file</mat-icon>
            Adicionar evidências
          </button>
          <button type="button" class="primary-btn" (click)="analyzeSelected()" [disabled]="analyzing || !evidences.length">
            <mat-icon>psychology</mat-icon>
            {{ analyzing ? 'Analisando...' : 'Analisar evidências' }}
          </button>
        </div>
      </header>

      <article class="panel detail-panel detail-panel--single">
        <ng-container *ngIf="selectedDossie; else selectEmpty">
          <div class="panel-header">
            <div>
              <h2>{{ selectedDossie.title }}</h2>
              <p>{{ selectedDossie.objective }}</p>
            </div>
            <small class="status-chip">{{ statusLabel(selectedDossie.status) }}</small>
          </div>

          <div class="detail-block">
            <strong>O que será enviado como evidência</strong>
            <p>{{ selectedDossie.evidence_guidance || 'Não informado.' }}</p>
          </div>
          <div class="detail-block">
            <strong>Prompt configurável do dossiê</strong>
            <p>{{ selectedDossie.ai_prompt || 'Não informado.' }}</p>
          </div>

          <section class="reanalyze-card">
            <div class="reanalyze-card__copy">
              <strong>Observações para reanálise</strong>
              <span>
                Use este campo para corrigir a leitura dos prints antes de rodar novamente.
                Ex.: mensagens à direita são do Marcelo; mensagens à esquerda são da Mikelle; ignore cabeçalhos do aplicativo; considere o horário visível no print.
              </span>
            </div>
            <textarea
              [(ngModel)]="analysisGuidanceDraft"
              placeholder="Informe como a IA deve reinterpretar as evidências. Ex.: no WhatsApp, balões verdes/direita são do Marcelo e balões brancos/esquerda são da Mikelle."></textarea>
            <div class="reanalyze-card__actions">
              <button type="button" class="ghost-btn" (click)="analyzeSelected()" [disabled]="analyzing || !evidences.length">
                <mat-icon>refresh</mat-icon>
                {{ analyzing ? 'Reanalisando...' : 'Reanalisar com observações' }}
              </button>
            </div>
          </section>

          <section class="analysis-report" *ngIf="selectedDossie.final_report; else analysisEmpty">
            <header>
              <div>
                <h3>Relatório operacional</h3>
                <span>Última análise: {{ formatDate(selectedDossie.last_analyzed_at) }}</span>
              </div>
              <div class="report-actions">
                <button type="button" class="mini-btn" *ngIf="!editingReport" (click)="startEditReport()">
                  <mat-icon>edit</mat-icon>
                  Editar
                </button>
                <button type="button" class="mini-btn" *ngIf="!editingReport" (click)="exportReport()">
                  <mat-icon>download</mat-icon>
                  Exportar
                </button>
                <button type="button" class="mini-btn success" *ngIf="!editingReport && selectedDossie.status !== 'FINALIZED'" (click)="finalizeSelected()">
                  <mat-icon>task_alt</mat-icon>
                  Finalizar
                </button>
                <small class="status-chip" *ngIf="selectedDossie.status === 'FINALIZED'">Finalizado</small>
              </div>
            </header>
            <ng-container *ngIf="editingReport; else reportPreview">
              <textarea
                class="report-editor"
                [(ngModel)]="reportDraft"
                placeholder="Revise e ajuste o relatório operacional"></textarea>
              <footer class="report-edit-actions">
                <button type="button" class="ghost-btn" (click)="cancelEditReport()" [disabled]="saving">Cancelar</button>
                <button type="button" class="ghost-btn" (click)="saveReport()" [disabled]="saving">Salvar ajustes</button>
                <button type="button" class="primary-btn" (click)="saveReport('FINALIZED')" [disabled]="saving">Salvar e finalizar</button>
              </footer>
            </ng-container>
            <ng-template #reportPreview>
              <pre>{{ selectedDossie.final_report }}</pre>
            </ng-template>
          </section>

          <ng-template #analysisEmpty>
            <section class="analysis-report analysis-report--empty">
              <mat-icon>psychology_alt</mat-icon>
              <div>
                <strong>Sem relatório operacional.</strong>
                <span>Adicione evidências e clique em Analisar evidências para consolidar o dossiê.</span>
              </div>
            </section>
          </ng-template>

          <section class="evidence-list">
            <header>
              <h3>Evidências</h3>
              <span>{{ evidences.length }} item(ns)</span>
            </header>
            <article class="evidence-item" *ngFor="let evidence of evidences">
              <mat-icon>{{ evidence.evidence_type === 'AUDIO' ? 'mic' : evidence.evidence_type === 'IMAGE' ? 'image' : 'description' }}</mat-icon>
              <div>
                <strong>{{ evidence.title }}</strong>
                <small>
                  {{ evidenceTypeLabel(evidence.evidence_type) }}
                  · Inserida em {{ formatDate(evidence.created_at) }}
                  <ng-container *ngIf="evidence.facts_date"> · Fato em {{ formatDate(evidence.facts_date) }}</ng-container>
                </small>
                <p *ngIf="evidence.description">{{ evidence.description }}</p>
              </div>
              <button type="button" class="icon-btn danger" (click)="deleteEvidence(evidence)">
                <mat-icon>delete</mat-icon>
              </button>
            </article>
            <p class="empty" *ngIf="!evidences.length">Nenhuma evidência adicionada.</p>
          </section>
        </ng-container>
      </article>
    </ng-template>
  </section>
</main>

<ng-template #accessDenied>
  <section class="access-denied">
    <mat-icon>lock</mat-icon>
    <h2>Acesso restrito</h2>
    <p>O ControlDossie está disponível apenas para usuários Master e Admin.</p>
  </section>
</ng-template>

<ng-template #selectEmpty>
  <div class="empty-state tall">
    <mat-icon>folder_special</mat-icon>
    <strong>Selecione um dossiê.</strong>
    <span>As evidências e o prompt configurável aparecem aqui.</span>
  </div>
</ng-template>

<div class="cp-modal-backdrop" *ngIf="showDossieModal || showEvidenceModal" (click)="showDossieModal ? closeDossieModal() : closeEvidenceModal()"></div>

<section class="cp-modal cp-modal-fixed-height dossie-modal" *ngIf="showDossieModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <span class="modal-pill">CONTROLDOSSIE · DOSSIÊ</span>
      <h2>{{ editingDossie ? 'Editar dossiê' : 'Novo dossiê' }}</h2>
      <small>Configure objetivo, evidências esperadas e prompt operacional.</small>
    </div>
    <button class="icon" type="button" (click)="closeDossieModal()"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" (ngSubmit)="saveDossie()">
    <div class="cp-modal-scroll">
      <section class="cp-panel form-grid">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>Título do dossiê</mat-label>
          <input matInput [(ngModel)]="dossieForm.title" name="title" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>Objetivo do dossiê</mat-label>
          <textarea matInput rows="4" [(ngModel)]="dossieForm.objective" name="objective" required></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>O que será enviado de evidência</mat-label>
          <textarea matInput rows="4" [(ngModel)]="dossieForm.evidence_guidance" name="evidence_guidance"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>Prompt de comando do ControlDossie</mat-label>
          <textarea matInput rows="6" [(ngModel)]="dossieForm.ai_prompt" name="ai_prompt"></textarea>
        </mat-form-field>
      </section>
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn outline" (click)="closeDossieModal()">Cancelar</button>
      <button type="submit" class="btn primary" [disabled]="saving">{{ saving ? 'Salvando...' : 'Salvar dossiê' }}</button>
    </footer>
  </form>
</section>

<section class="cp-modal evidence-modal" *ngIf="showEvidenceModal" (click)="$event.stopPropagation()">
  <header class="modal-header">
    <div>
      <span class="modal-pill">CONTROLDOSSIE · EVIDÊNCIA</span>
      <h2>Adicionar evidência</h2>
      <small>O arquivo será salvo na pasta do dossiê no ControlDocs.</small>
    </div>
    <button class="icon" type="button" (click)="closeEvidenceModal()"><mat-icon>close</mat-icon></button>
  </header>
  <form class="cp-modal-body" (ngSubmit)="saveEvidence()">
    <div class="cp-modal-scroll">
      <section class="cp-panel form-grid two">
        <label class="file-drop file-drop--primary full">
          <mat-icon>upload_file</mat-icon>
          <strong>{{ evidenceFileLabel() }}</strong>
          <small>Envie prints, áudios, PDFs ou documentos. Você pode selecionar múltiplos arquivos.</small>
          <input type="file" multiple (change)="onEvidenceFileChange($event)">
        </label>
        <div class="selected-files full" *ngIf="evidenceFiles.length">
          <span *ngFor="let file of evidenceFiles">{{ file.name }}</span>
        </div>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Tipo</mat-label>
          <mat-select [(ngModel)]="evidenceForm.evidence_type" name="evidence_type">
            <mat-option value="TEXT">Texto</mat-option>
            <mat-option value="IMAGE">Print / imagem</mat-option>
            <mat-option value="AUDIO">Áudio</mat-option>
            <mat-option value="VIDEO">Vídeo</mat-option>
            <mat-option value="PDF">PDF</mat-option>
            <mat-option value="DOCUMENT">Documento</mat-option>
            <mat-option value="LINK">Link</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Data dos fatos</mat-label>
          <input matInput type="date" [(ngModel)]="evidenceForm.facts_date" name="facts_date">
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>Título</mat-label>
          <input matInput [(ngModel)]="evidenceForm.title" name="evidence_title">
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>Comentário da evidência</mat-label>
          <textarea matInput rows="3" [(ngModel)]="evidenceForm.description" name="description"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>Texto ou mensagem</mat-label>
          <textarea matInput rows="5" [(ngModel)]="evidenceForm.text_content" name="text_content"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field full">
          <mat-label>Link de origem</mat-label>
          <input matInput [(ngModel)]="evidenceForm.source_url" name="source_url">
        </mat-form-field>
      </section>
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn outline" (click)="closeEvidenceModal()">Cancelar</button>
      <button type="submit" class="btn primary" [disabled]="saving">{{ saving ? 'Salvando...' : 'Adicionar evidência' }}</button>
    </footer>
  </form>
</section>
